import React, { Component } from "react";
import StimsTableContainer from "./containers/StimsTableContainer";
import { connect } from "react-redux";
import { stimsOperations } from "./duck/index";
import LoadingSpinner from "../common/components/LoadingSpinner";
import DropDown from "../EditStudyDetails/components/DropDown";
import { addAllType } from "../Dashboard/DashboardContainer";
import ToolTip from "../common/components/Tooltip";
import Paper from "@mui/material/Paper";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import TablePagination from "../common/components/Pagination";
import PrettyDropdown2 from "../common/components/PrettyDropDown2";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { withRouter } from "react-router-dom";
import StimService from "./StimService";
import StudyTabNavigation from "../Overview/containers/StudyTabNavigation";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import FiltersRow from '../components/FiltersRow';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
const filterInputSx = {
  "& .MuiOutlinedInput-root": {
    height: "34px",
    backgroundColor: "#fff",
    borderRadius: 0,           
    paddingRight: "4px",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },

  "& .MuiOutlinedInput-input": {
    padding: "7px 8px",
  },
};

class Stims extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilter: false,
      stimsPerPage: 25,
      pageNum: 1,
      orderBy: "name_asc",
      filterName: "",
      filterMediaId: 0,
      filterStimType: "",
      filterBrandId: 0,
      selectedStims: [],
      snackbarOpen: !!props.location.state?.snackbarMessage,
      snackbarMessage: props.location.state?.snackbarMessage || "",
      snackbarSeverity: props.location.state?.snackbarSeverity || "success",
      clutter:  "all" ,
      deleteConfirmOpen: false,
      deleteSubmitting: false,
      deleteResult: null,     
      filterCountryId: 0,
      filterLanguageId: 0,
      filterAdTypeId: 0,
      filterImportant: "all",
      adTypesOptions: [],
      actionsAnchorEl: null,
      filterCreatedFrom: null,
      filterCreatedTo: null,
    };
    this.myTimer = React.createRef(null);
  }

saveFiltersToSession = () => {
  const {
    filterName,
    filterMediaId,
    filterStimType,
    filterBrandId,
    stimsPerPage,
    pageNum,
    orderBy,
    showFilter,
    clutter,
    filterCountryId,
    filterLanguageId,
    filterAdTypeId,
    filterImportant,
    filterCreatedFrom,
    filterCreatedTo,
  } = this.state;

  const payload = {
    filterName,
    filterMediaId,
    filterStimType,
    filterBrandId,
    stimsPerPage,
    pageNum,
    orderBy,
    showFilter,
    clutter, 
    filterCountryId,
    filterLanguageId,
    filterAdTypeId,
    filterImportant,
    filterCreatedFrom,
    filterCreatedTo,
  };

  sessionStorage.setItem("stims_filters", JSON.stringify(payload));
};


  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

async componentDidMount() {
  const saved = sessionStorage.getItem("stims_filters");
  let restoredFilters = {};

if (saved) {
  restoredFilters = JSON.parse(saved);

  if (restoredFilters.clutter === true) restoredFilters.clutter = "true";
  if (restoredFilters.clutter === false) restoredFilters.clutter = "false";

  if (restoredFilters.clutter == null || restoredFilters.clutter === "") {
    restoredFilters.clutter = "all";
  }
  if (!["all", "true", "false"].includes(restoredFilters.clutter)) {
    restoredFilters.clutter = "all";
  }

  if (restoredFilters.filterCountryId == null) restoredFilters.filterCountryId = 0;
  if (restoredFilters.filterLanguageId == null) restoredFilters.filterLanguageId = 0;
  if (restoredFilters.filterAdTypeId == null) restoredFilters.filterAdTypeId = 0;
  if (!restoredFilters.filterImportant) restoredFilters.filterImportant = "all";

  const parseDate = (v) => {
    if (!v) return null;
    const d = v instanceof Date ? v : new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  };

  restoredFilters.filterCreatedFrom = parseDate(restoredFilters.filterCreatedFrom);
  restoredFilters.filterCreatedTo = parseDate(restoredFilters.filterCreatedTo);

  this.setState({ ...restoredFilters });
}


  const {
    stimsPerPage,
    pageNum,
    orderBy,
    filterName,
    filterMediaId,
    filterStimType,
    filterBrandId,
    clutter,
    filterCountryId,
    filterLanguageId,
    filterAdTypeId,
    filterImportant,
    filterCreatedFrom,
    filterCreatedTo,
  } = restoredFilters;

  const filterStudyId = parseInt(this.props.match.params.studyId) || null;

  await this.props.getTypes();

  const adTypesRes = await StimService.getAdTypes();
  const formattedAdTypes = (adTypesRes.data || []).map(t => ({
    code: t.id,
    description: t.name
  }));

  this.setState({
    adTypesOptions: addAllType(formattedAdTypes)
  });

  await this.props.getStims(
    stimsPerPage || this.state.stimsPerPage,
    pageNum || this.state.pageNum,
    orderBy || this.state.orderBy,
    filterName || "",
    filterMediaId || 0,
    filterStimType || "",
    filterBrandId || 0,
    filterStudyId,
    clutter === "all" ? null : clutter,
    filterCountryId,
    filterLanguageId,
    filterAdTypeId,
    filterImportant,
    filterCreatedFrom,
    filterCreatedTo,

  );

  window.addEventListener("scroll", this.handleScroll, { passive: true });
}

  goBackToOverview = () => {
    // this.props.history.push(`my_studies/overview/:studyId`);
    this.props.history.push(
      `/my_studies/overview/:studyId/study-specific-stims`
    );
  };
  // /my_studies/overview/study-specific-stims
  // /my_studies/overview/24

  componentWillUnmount() {
    this.props.fetchStimsBegin();
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const currentScrollTop = window.scrollY;
    this.setState((prevState) => ({
      hideNav: currentScrollTop > prevState.lastScrollTop,
      lastScrollTop: currentScrollTop,
    }));
  };

  onUploadStimClick = () => {
    this.props.history.push("/stims/upload-stim");
  };

  handlefilterMediaChange = (filterMediaId) => {
  this.setState({ filterMediaId, pageNum: 1 }, () => {
    this.saveFiltersToSession();
    this.reloadStims();
  });
};

  handlefilterStimTypeChange = (filterStimType) => {
  this.setState({ filterStimType, pageNum: 1 }, () => {
    this.saveFiltersToSession();
    this.reloadStims();
  });
};

  handlepageNumChange = (event, newPage) => {
  this.setState({ pageNum: newPage || 1 }, () => {
    this.saveFiltersToSession();
    this.reloadStims();
  });
};

 handleStimsPerPageChange = (event) => {
  const stimsPerPage = event.target.value;
  this.setState({ stimsPerPage, pageNum: 1 }, () => {
    this.saveFiltersToSession();
    this.reloadStims();
  });
};


  handleSortChange = (orderBy) => {
  this.setState({ orderBy, pageNum: 1 }, () => {
    this.saveFiltersToSession();
    this.reloadStims();
  });
};

  handleSearchChange = (filterName) => {
  this.setState({ filterName, pageNum: 1 }, () => {
    this.saveFiltersToSession();
  });
  clearTimeout(this.myTimer);
  this.myTimer = setTimeout(this.reloadStims, 500);
};


  handleStimsSelection = (selectedStims) => {
    this.setState({ selectedStims });
    console.log("Selected Stims:", selectedStims);
  };

confirmDeleteStims = async () => {
  const { selectedStims } = this.state;
  if (!selectedStims.length) return;

  this.setState({ deleteSubmitting: true });

  try {
    const stimlist = selectedStims.map((id) => ({ stimid: id, action: "delete" }));
    const res = await StimService.stimAction(stimlist);

    const resultList = res?.data?.result_list || [];
    const failed = resultList.filter((r) => r.success !== true);

    this.setState({
      deleteResult: { failed, resultList },
      deleteConfirmOpen: false,
      selectedStims: [],
    });

    if (failed.length) {
      this.setState({
        snackbarOpen: true,
        snackbarMessage: `Deleted with some failures. Failed: ${failed.length}`,
        snackbarSeverity: "warning",
      });
      console.error("Failed deletions:", failed);
    } else {
      this.setState({
        snackbarOpen: true,
        snackbarMessage: "Stims deleted successfully.",
        snackbarSeverity: "success",
      });
    }

    this.reloadStims();
  } catch (error) {
    console.error("Error deleting stims:", error);

    this.setState({
      snackbarOpen: true,
      snackbarMessage: "Error deleting stims.",
      snackbarSeverity: "error",
      deleteConfirmOpen: false,
    });
  } finally {
    this.setState({ deleteSubmitting: false });
  }
};

resetCreatedDateFilters = () => {
  this.setState(
    { filterCreatedFrom: null, filterCreatedTo: null, pageNum: 1 },
    () => {
      this.saveFiltersToSession();
      this.reloadStims();
    }
  );
};

  reloadStims = () => {
    const {
      stimsPerPage,
      pageNum,
      orderBy,
      filterName,
      filterMediaId,
      filterStimType,
      clutter,
      filterCountryId,
      filterLanguageId,
      filterAdTypeId,
      filterImportant,
      filterCreatedFrom,
      filterCreatedTo,
    } = this.state;

    const filterStudyId = parseInt(this.props.match.params.studyId) || null;

    this.props.getStims(
      stimsPerPage,
      pageNum,
      orderBy,
      filterName,
      filterMediaId,
      filterStimType,
      this.state.filterBrandId,
      filterStudyId,
      clutter === "all" ? null : clutter,
      filterCountryId,
      filterLanguageId,
      filterAdTypeId,
      filterImportant,
      filterCreatedFrom,
      filterCreatedTo
    );
  };

openDeleteConfirmDialog = () => {
  this.setState({ deleteConfirmOpen: true, deleteResult: null });
};

closeDeleteConfirmDialog = () => {
  this.setState({ deleteConfirmOpen: false });
};

handleDeleteConfirmExited = () => {
  this.setState({ deleteSubmitting: false, deleteResult: null });
};

openActionsMenu = (e) => {
  this.setState({ actionsAnchorEl: e.currentTarget });
};

closeActionsMenu = () => {
  this.setState({ actionsAnchorEl: null });
};

  render() {
    const { loading, mediaTypes, stimTypes } = this.props;
    const { showFilter, filterName, stimsPerPage, isDeleting } = this.state;
    const studyId = this.props.match.params.studyId;
    const selectedAdType =
  (this.state.adTypesOptions || []).find((a) => a.code === this.state.filterAdTypeId) || null;
    
    return (
      <>
        <StudyTabNavigation hidden={this.state.hideNav} />
        <Paper elevation={0} style={{ borderRadius: 16 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "16px",
              alignItems: "center",
            }}
          >
          <TextField
  autoFocus
  onChange={(e) => this.handleSearchChange(e.target.value)}
  value={filterName}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon />
      </InputAdornment>
    ),
  }}
  label="Search my stims..."
  variant="outlined"
  sx={{
    "& .MuiOutlinedInput-root": {
      backgroundColor: "transparent",    
      boxShadow: "none",          
    },
    "& .MuiOutlinedInput-input": {
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
    },
  }}
/>


            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Tooltip placement="bottom" title="Filter stims">
                <IconButton
                  onClick={() => this.setState({ showFilter: !showFilter })}
                  size="large"
                >
                  <FilterListIcon style={{ color: "rgb(99, 115, 129)" }} />
                </IconButton>
              </Tooltip>
              {/* comditionally render the Upload button */}
              {!studyId && (
                <Button
  className="button-primary"
  size="small"
  startIcon={<AddIcon />}
  onClick={this.onUploadStimClick}
>
  Upload Stim
</Button>
              )}

<Button
  variant="contained"
  size="small"
  endIcon={<KeyboardArrowDownIcon />}
  className={`button-secondary ${
    !this.state.selectedStims?.length || this.state.deleteSubmitting ? "disabled" : ""
  }`}
  disabled={!this.state.selectedStims?.length || this.state.deleteSubmitting}
  onClick={this.openActionsMenu}
  title={
    this.state.selectedStims?.length
      ? "Bulk actions for selected stims"
      : "Select at least one stim"
  }
>
  Actions
</Button>

<Menu
  anchorEl={this.state.actionsAnchorEl}
  open={!!this.state.actionsAnchorEl}
  onClose={this.closeActionsMenu}
  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
  transformOrigin={{ vertical: "top", horizontal: "left" }}
>
  <MenuItem
    onClick={(e) => {
      e.stopPropagation();
      this.setState({ actionsAnchorEl: null }, () => {
        this.openDeleteConfirmDialog();
      });
    }}
  >
    Delete selected
  </MenuItem>
</Menu>

            </div>
          </div>

          {loading ? (
            <LoadingSpinner style={{ padding: "25vh", margin: "auto" }} />
          ) : (
            <>
{showFilter && (
  <div
    style={{
      padding: "0 16px 16px",
      display: "flex",
      flexDirection: "column",
      gap: 12,
    }}
  >
    {/* row 1*/}
    <div style={{ position: "relative", zIndex: 2 }}>
      <FiltersRow
        columns={[
          {
            key: "stimType",
            label: "Stim Type",
            minWidth: 160,
            control: (
              <div style={{ width: "100%", height: 34, display: "flex", alignItems: "center" }}>
                <DropDown
                  className="left"
                  value={this.state.filterStimType || "All"}
                  onSelectItem={(selected) => {
                    const map = {
                      All: "",
                      Script: "s",
                      "VAST URL": "va",
                      "VAST XML": "vx",
                      Image: "i",
                      Video: "v",
                    };
                    this.handlefilterStimTypeChange(map[selected] || "");
                  }}
                  options={["All", "Script", "VAST URL", "VAST XML", "Image", "Video"]}
                />
              </div>
            ),
          },
          {
            key: "brand",
            label: "Brand",
            minWidth: 200,
            control: (
              <Autocomplete
                size="small"
                options={this.props.brandTypes}
                getOptionLabel={(option) => option.description || ""}
                isOptionEqualToValue={(option, value) => option.code === value.code}
                value={
                  this.props.brandTypes.find((b) => b.code === this.state.filterBrandId) || null
                }
                onChange={(e, newValue) => {
                  const id = newValue?.code || 0;
                  this.setState({ filterBrandId: id, pageNum: 1 }, () => {
                    this.saveFiltersToSession();
                    this.reloadStims();
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" sx={filterInputSx} />
                )}
              />
            ),
          },
          {
            key: "clutter",
            label: "Clutter",
            minWidth: 170,
            control: (
              <div style={{ width: "100%", height: 34, display: "flex", alignItems: "center" }}>
                <DropDown
                  className="left"
                  value={
                    this.state.clutter === "true"
                      ? "Clutter"
                      : this.state.clutter === "false"
                      ? "Test"
                      : "All"
                  }
                  onSelectItem={(selected) => {
                    const label =
                      typeof selected === "string"
                        ? selected
                        : selected?.target?.value ||
                          selected?.description ||
                          selected?.label ||
                          selected?.value;

                    const map = { All: "all", Clutter: "true", Test: "false" };
                    const nextClutter = map[label] ?? "all";

                    this.setState({ clutter: nextClutter, pageNum: 1 }, () => {
                      this.saveFiltersToSession();
                      this.reloadStims();
                    });
                  }}
                  options={["All", "Clutter", "Test"]}
                />
              </div>
            ),
          },
          {
            key: "country",
            label: "Country",
            minWidth: 200,
            control: (
              <Autocomplete
                size="small"
                options={this.props.locationTypes}
                getOptionLabel={(option) => option.description || ""}
                value={
                  this.props.locationTypes.find((l) => l.code === this.state.filterCountryId) || null
                }
                onChange={(e, newValue) => {
                  const id = newValue?.code || 0;
                  this.setState({ filterCountryId: id, pageNum: 1 }, () => {
                    this.saveFiltersToSession();
                    this.reloadStims();
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" sx={filterInputSx} />
                )}
              />
            ),
          },
          {
            key: "language",
            label: "Language",
            minWidth: 200,
            control: (
              <Autocomplete
                size="small"
                options={this.props.languageTypes}
                getOptionLabel={(option) => option.description || ""}
                value={
                  this.props.languageTypes.find((l) => l.code === this.state.filterLanguageId) || null
                }
                onChange={(e, newValue) => {
                  const id = newValue?.code || 0;
                  this.setState({ filterLanguageId: id, pageNum: 1 }, () => {
                    this.saveFiltersToSession();
                    this.reloadStims();
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" sx={filterInputSx} />
                )}
              />
            ),
          },
          {
            key: "adType",
            label: "Ad Type",
            minWidth: 200,
            control: (
              <Autocomplete
                size="small"
                options={this.state.adTypesOptions}
                getOptionLabel={(option) => option.description || ""}
                isOptionEqualToValue={(option, value) => option.code === value.code}
                value={
                  this.state.adTypesOptions.find((a) => a.code === this.state.filterAdTypeId) ||
                  null
                }
                onChange={(e, newValue) => {
                  const id = newValue?.code || 0;
                  this.setState({ filterAdTypeId: id, pageNum: 1 }, () => {
                    this.saveFiltersToSession();
                    this.reloadStims();
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" sx={filterInputSx} />
                )}
              />
            ),
          },
        ]}
      />
    </div>

    {/* row 2 */}
    <div style={{ position: "relative", zIndex: 1 }}>
      <FiltersRow
        columns={[
          {
            key: "createdDate",
            label: "Created",
            minWidth: 320,
            control: (
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <div style={{ display: "flex", gap: 8, alignItems: "center", width: "100%" }}>
                  <DatePicker
                    label="From"
                    value={
                      this.state.filterCreatedFrom instanceof Date &&
                      !Number.isNaN(this.state.filterCreatedFrom.getTime())
                        ? this.state.filterCreatedFrom
                        : null
                    }
                    onChange={(v) => {
                      this.setState({ filterCreatedFrom: v, pageNum: 1 }, () => {
                        this.saveFiltersToSession();
                        this.reloadStims();
                      });
                    }}
                    slotProps={{
                      textField: { size: "small", variant: "outlined", sx: filterInputSx },
                    }}
                  />
                  <DatePicker
                    label="To"
                    value={
                      this.state.filterCreatedTo instanceof Date &&
                      !Number.isNaN(this.state.filterCreatedTo.getTime())
                        ? this.state.filterCreatedTo
                        : null
                    }
                    onChange={(v) => {
                      this.setState({ filterCreatedTo: v, pageNum: 1 }, () => {
                        this.saveFiltersToSession();
                        this.reloadStims();
                      });
                    }}
                    minDate={
                      this.state.filterCreatedFrom instanceof Date &&
                      !Number.isNaN(this.state.filterCreatedFrom.getTime())
                        ? this.state.filterCreatedFrom
                        : undefined
                    }
                    slotProps={{
                      textField: { size: "small", variant: "outlined", sx: filterInputSx },
                    }}
                  />
                  <Button
                    size="small"
                    className="button-secondary"
                   
                    disabled={!this.state.filterCreatedFrom && !this.state.filterCreatedTo}
                    onClick={this.resetCreatedDateFilters}
                    style={{ height: 34, minWidth: 90 }}
                  >
                    Reset
                  </Button>
                </div>
              </LocalizationProvider>
            ),
          },
        ]}
      />
    </div>
  </div>
)}




              <div style={{ marginRight: 8 }}>
                <TablePagination
                  rowsPerPage={stimsPerPage}
                  onRowsPerPageChange={this.handleStimsPerPageChange}
                  numberOfPages={this.props.stims.total_page_num}
                  currentPage={this.props.stims.page_num}
                  onPageChange={this.handlepageNumChange}
                />
              </div>

              <div className="stims__table-container">
                <StimsTableContainer
                  currentOrderBy={this.state.orderBy}
                  handleSortChange={this.handleSortChange}
                  //pass to stimstable
                  onStimsSelection={this.handleStimsSelection}
                  onUploadStimClick={this.onUploadStimClick}
                />
              </div>

              <div style={{ marginRight: 8 }}>
                <TablePagination
                  rowsPerPage={stimsPerPage}
                  onRowsPerPageChange={this.handleStimsPerPageChange}
                  numberOfPages={this.props.stims.total_page_num}
                  currentPage={this.props.stims.page_num}
                  onPageChange={this.handlepageNumChange}
                />
              </div>
            </>
          )}
        </Paper>

{/* delete confirmation modals*/}
<Dialog
  open={this.state.deleteConfirmOpen}
  onClose={this.closeDeleteConfirmDialog}
  maxWidth="sm"
  fullWidth
  disableRestoreFocus
  disableEnforceFocus
  TransitionProps={{ onExited: this.handleDeleteConfirmExited }}
>
  <DialogTitle
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pr: 1,
    }}
  >
    <span>Delete selected stims</span>

    <IconButton
      aria-label="close"
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeDeleteConfirmDialog();
      }}
      size="small"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    <Typography variant="body2" style={{ marginBottom: 12 }}>
      You are about to delete <b>{this.state.selectedStims.length}</b> stim(s).
      This will remove them from your list.
    </Typography>

    <Divider style={{ margin: "12px 0" }} />

    <Typography variant="body2" style={{ marginBottom: 8 }}>
      Stim IDs to delete:
    </Typography>

    <List dense>
      {this.state.selectedStims.map((id) => (
        <ListItem key={`delete-stim-${id}`}>{id}</ListItem>
      ))}
    </List>
  </DialogContent>

  <DialogActions>
    <Button
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeDeleteConfirmDialog();
      }}
      className="button-secondary"
      size="small"
      disabled={this.state.deleteSubmitting}
    >
      Cancel
    </Button>

    <Button
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        this.confirmDeleteStims();
      }}
      className="button-secondary"
      variant="contained"
      size="small"
      disabled={this.state.deleteSubmitting}
    >
      {this.state.deleteSubmitting ? "Deleting..." : "OK"}
    </Button>
  </DialogActions>
</Dialog>


        <Snackbar
          open={this.state.snackbarOpen}
          autoHideDuration={20000}
          onClose={this.handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={this.handleSnackbarClose}
            severity={this.state.snackbarSeverity}
            variant="outlined"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={this.handleSnackbarClose}
              >
                OK
              </Button>
            }
          >
            {this.state.snackbarMessage}
          </Alert>
        </Snackbar>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    mediaTypes: addAllType(state.stimsReducer.mediaTypes),
    stimTypes: addAllType(state.stimsReducer.stimTypes),
    loading: state.stimsReducer.loading,
    brandTypes: addAllType(
      (state.stimsReducer.brandTypes || []).map(b => ({
        code: b.id,
        description: b.name
      }))
      
    ),
    stims: state.stimsReducer.stims,
    locationTypes: addAllType(
  (state.stimsReducer.locationTypes || []).map(l => ({
    code: l.id,
    description: l.name
  }))
),

languageTypes: addAllType(
  (state.stimsReducer.languageTypes || []).map(l => ({
    code: l.id,
    description: l.name
  }))
),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getTypes: () => dispatch(stimsOperations.getTypes()), 

    getStims: (
      stimsPerPage,
      pageNum,
      orderBy,
      filterName,
      filterMediaId,
      filterStimType,
      filterBrandId,
      filterStudyId,
      clutter,
      filterCountryId,
      filterLanguageId,
      filterAdTypeId,
       filterImportant,  
      filterCreatedFrom,
      filterCreatedTo
    ) =>
      dispatch(
        stimsOperations.getStimsData(
          stimsPerPage,
          pageNum,
          orderBy,
          filterName,
          filterMediaId,
          filterStimType,
          filterBrandId,
          filterStudyId,
          clutter,
          filterCountryId,
          filterLanguageId,
          filterAdTypeId,
          filterImportant,  
          filterCreatedFrom,
          filterCreatedTo
        )
      ),
    fetchStimsBegin: () => dispatch(stimsOperations.fetchStimsBegin()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Stims));
